<template>
  <div class="c c-product-overview__controls">
    <div class="c-product-overview__controls--left">
      <image-type-switch />

      <span class="c-product-overview__count">
        {{ totalCount }}
        {{ getProductOverviewTranslations['ProductsOverview.Results'] }}
      </span>
    </div>

    <div>
      <items-per-page />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import ItemsPerPage from './items-per-page.vue';
import ImageTypeSwitch from './image-type-switch.vue';

export default {
  components: {
    ItemsPerPage,
    ImageTypeSwitch
  },
  computed: {
    ...mapGetters('productSearch', ['buildQuery']),
    ...mapState('productSearch', [
      'isPending',
      'paginationSettings',
      'imageType',
      'totalCount'
    ]),
    ...mapGetters('translations', ['getProductOverviewTranslations']),
    localImageType: {
      get() {
        return this.imageType;
      },
      set(value) {
        this.setImageType(value);
      }
    }
  },
  methods: {
    ...mapMutations('productSearch', ['setImageType'])
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/src/utilities/_variables.scss';
@import '~bootstrap/scss/mixins';

.c-product-overview {
  &__controls {
    display: flex;
    justify-content: space-between;
    padding-bottom: 15px;
    border-bottom: 1px solid $grey;

    &.c {
      margin-bottom: 30px;
    }

    &--left {
      display: flex;
      gap: 20px;
      align-items: center;
    }
  }

  &__count {
    display: inline-block;
  }
}
</style>
